import { RootState } from '@app/store'
import { api as agoraApi } from './auto-generated/agora'
import { api as eventApi } from './auto-generated/event'
import { createSocket } from './ws'

agoraApi.enhanceEndpoints({
  endpoints: {
    agoraCreateNewRoom: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(
            eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
              draftEvent.current_room_id = data.room_id
            }),
          )
          dispatch(
            eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
              if (draftEvent) {
                draftEvent.current_room_id = data.room_id
              }
            }),
          )
        } catch {
          console.error('something went wrong')
        }
      },
    },
    agoraGetRtcRooms: {
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved, getState },
      ) {
        const { tokens } = (getState() as RootState).auth
        const { eventId } = arg
        let ws
        if (tokens && eventId) {
          try {
            await cacheDataLoaded
            const listener = (event: MessageEvent) => {
              const data = JSON.parse(event.data)
              updateCachedData((draftRtcRooms) => {
                switch (data.event_type) {
                  case 'AGORA_CREATE_NEW_ROOM':
                    draftRtcRooms.push(data.event_message)
                    break
                  default:
                    break
                }
              })
            }
            ws = await createSocket(eventId, listener)
          } catch {
            console.error('something went wrong')
          }
          await cacheEntryRemoved
          if (ws) {
            ws.close()
          }
        }
      },
    },
  },
})

export { agoraApi }
